import React, {useRef, useEffect, useState} from "react"
import ImgBuilder from "../../res/img/imgBuilder"
import { useFormik, Field, Formik, Form, ErrorMessage } from "formik"
import SimpleInput from "../../components/FormFields/SimleInput"
import GoBackButton from "../../components/GoBackButton"
import * as yup from 'yup'
import LoginSchema from "../../res/validationSchemes/login"
import { useNavigate } from "react-router"
import { mailLink } from "../../res/consts/router_urls_const"
import { inject, observer } from "mobx-react"
import DropdownInput from "../../components/Filters/DropdownInput"

import "./styles.scss"

const LoginPage = (props) => {
    const {
        authModel:{
            signIn,
            serverErrors,
            setErrorsEmpty
        },
        serverAPImodel:{
            setBaseAPI,
            baseAPI,
            baseAPILogin
        }
    } = props

    const [formWidth, setFormWidth] = useState(0)
    const [formHeight, setFormHeight] = useState(0)
    const [serverName, setServerName] = useState(1)
    const [typeOfFields, setTypeOfFields] = useState("login")
    const [initValuesForm, setInitValuesForm] = useState({
        email: '',
        password:'',
    })
    
    const [validationSchema, setValidationSchema] = useState(LoginSchema)
    const [serverErrorsState, setServerErrorsState] = useState({email:"", password:""})

    const navigate = useNavigate()

    const formRef = useRef(null)

    useEffect(()=>{
        if(formRef){
            setFormWidth(formRef.current.offsetWidth)
            setFormHeight(formRef.current.offsetHeight)
        }
    },[formRef])

    useEffect(() => {
        if(typeOfFields === "login"){
            setInitValuesForm({
                email: '',
                password:'',
            })
            setValidationSchema(LoginSchema)
        }
    },[typeOfFields])

    useEffect(() => {
        setServerErrorsState(JSON.parse(JSON.stringify(serverErrors)))
    }, [serverErrors.password, serverErrors.email])

    const submitlogin = (values) =>{
        if(typeOfFields === "login"){
            switch (values.server){
                case "DEMO":
                    setServerWrapper(1)
                    setBaseAPI(1)
                    break;
                case "SpotlogicQA":
                    setServerWrapper(2)
                    setBaseAPI(2)
                    break;
                case "Xerox":
                    setServerWrapper(3)
                    setBaseAPI(3)
                    break;
                case "WWT":
                    setServerWrapper(4)
                    setBaseAPI(4)
                    break;
                case "NetApp":
                    setServerWrapper(5)
                    setBaseAPI(5)
                    break;
                case "HashiCorp":
                    setServerWrapper(6)
                    setBaseAPI(6)
                    break;
                case "SolRenewables":
                    setServerWrapper(7)
                    setBaseAPI(7)
                    break;
                case "ScholarPath":
                    setServerWrapper(8)
                    setBaseAPI(8)
                    break;
            }
            signIn(values)
        }
    }

    const handleSecretInput = (e) =>{
        if(e.target.value.length > 1){
            if((e.target.value.match(/1/g) || []).length > (e.target.value.match(/2/g) || []).length){
                setServerName(1)
                setBaseAPI(1)
            }else{
                setServerName(2)
                setBaseAPI(2)
            }
        } 
    }

    const setServerWrapper = (item) =>{
        setServerName(item.number)
        setBaseAPI(item.number)
    }

    return <div className = "pageContainerLoginPage">
    
        <div className = "containerLoginPage align-items-center" style = {{
            boxShadow: `${serverName === 2 ? "0px 2px 10px hsla(210, 99%, 71%, 0.5)" : "0px 2px 10px rgba(186, 188, 201, 0.5)"}`
            }}>
            <div className = "leftsideContainerLoginPage" ref = {formRef}>
                <input className="oneSimpleInput" onChange = {(e) => handleSecretInput(e)}/>
                {typeOfFields === "login" ? <div className = "titleLoginPage">
                    <div className = "textTitleLoginPage">welcome to</div>
                    <img src = {ImgBuilder.mainlogoTM}/>
                </div> : <div></div>}
                <Formik
                    initialValues= {initValuesForm}
                    onSubmit = {values => submitlogin(values)}
                    validationSchema = {validationSchema}
                >         
                    {({ errors, touched }) => ( 
                        <Form>
                            <SimpleInput 
                                type = "text" 
                                label = "Enter Server"
                                width = {300} 
                                required = {true} 
                                name = "server"
                                serverError = {serverErrorsState.server}
                                setErrorsEmpty = {setErrorsEmpty}
                                maxlength="48"
                            />
                            <SimpleInput 
                                type = "email" 
                                label = "Email" 
                                width = {300} 
                                required = {true} 
                                name = "email"
                                serverError = {serverErrorsState.email}
                                setErrorsEmpty = {setErrorsEmpty}
                                maxlength="48"
                            />
                            <SimpleInput 
                                type = "password" 
                                label = "Password" 
                                width = {300} 
                                required = {true} 
                                name = "password"
                                serverError = {serverErrorsState.password}
                                setErrorsEmpty = {setErrorsEmpty}
                                maxlength="48"
                            />
                            <div className = "actionsLoginPage">
                                <button type="submit">Login</button>
                            </div>
                        </Form>
                    )}              
                </Formik>
            </div>
            <div className = "rightsideContainerLoginPage" style = {{
                background: `url(${ImgBuilder.loginImage})`, 
                width:`${formWidth}px`,
                height:`${formHeight}px`
            }}>  
            </div>
        </div>
        
    </div>
}

export default inject(
    "authModel",
    "serverAPImodel"
)(observer(LoginPage))